export default {"src":"/_next/static/media/yellowStart.225bf65c.svg","height":23,"width":18,"blurWidth":0,"blurHeight":0};